var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_3",
    "data-name": "Capa 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16V7.5c0-1.3.6-2.4,1.6-3.2L6.8.4c.7-.5,1.7-.5,2.4,0l5.2,3.9c1,.8,1.6,1.9,1.6,3.2v8.5c0,1.1-.9,2-2,2h-2.3c-.6,0-1-.4-1-1v-3.5c0-1.5-1.2-2.7-2.7-2.7,0,0,0,0-.1,0-1.5.1-2.6,1.4-2.6,2.8v3.3c0,.6-.4,1-1,1h-2.3c-1.1,0-2-.9-2-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.7ad0c547.svg";
export { ForwardRef as ReactComponent };